import React, { Component } from 'react';
import SpinnerError from '$components/library/SpinnerError';
import { Query } from '@apollo/react-components';
import { gql } from '@apollo/client';
import FlashcardsExport from './FlashcardsExport';
import FlashcardsImport from './FlashcardsImport';
import FlashcardEdit from './FlashcardEdit';
import styles from './styles.scss';

const STAFF_PRODUCT_FLASHCARDS = gql`
  query StaffProductFlashcards($input: ProductInput!) {
    product(input: $input) {
      product {
        uuid
        numItems
        numItemsDynamic
        numExamItems
        numExamItemsDynamic
      }
    }
  }
`;

class ProductFlashcards extends Component {
  render() {
    const { match } = this.props;
    const { params } = match;
    const { productSlug } = params;

    return (
      <div className={styles.layout}>
        <Query
          query={STAFF_PRODUCT_FLASHCARDS}
          variables={{ input: { slug: productSlug } }}
        >
          {({ loading, error, data }) => {
            if (loading || error) {
              return <SpinnerError error={error} />;
            }

            const {
              product: { product },
            } = data;
            const {
              uuid: productUuid,
              numItems,
              numItemsDynamic,
              numExamItems,
              numExamItemsDynamic,
            } = product;

            return (
              <div>
                <div>
                  Flashcards:
                  <br />
                  <ul>
                    <li>
                      {numItems} quiz questions ({numItemsDynamic} dynamic)
                    </li>
                    <li>
                      {numExamItems} exam questions ({numExamItemsDynamic} dynamic)
                    </li>
                  </ul>
                </div>
                <hr />
                <FlashcardsExport productUuid={productUuid} />
                <hr />
                <FlashcardsImport productUuid={productUuid} />
                <hr />
                <FlashcardEdit />
              </div>
            );
          }}
        </Query>
      </div>
    );
  }
}

export default ProductFlashcards;
